import React, { useEffect, useState } from "react";
import "./SuccessPage.css";

function SuccessPage({ email, onClose }) {
  const [confetti, setConfetti] = useState([]);

  useEffect(() => {
    // Generate confetti particles
    const particles = [];
    for (let i = 0; i < 20; i++) {
      particles.push({
        id: i,
        left: Math.random() * 100,
        delay: Math.random() * 0.5,
        duration: 4 + Math.random() * 2,
      });
    }
    setConfetti(particles);

    // Remove confetti after animation completes
    const timer = setTimeout(() => {
      setConfetti([]);
    }, 7000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="success-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="close-btn" onClick={onClose}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M18 6L6 18M6 6L18 18"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        </button>

        {confetti.map((particle) => (
          <div
            key={particle.id}
            className="confetti"
            style={{
              left: `${particle.left}%`,
              animationDelay: `${particle.delay}s`,
              animationDuration: `${particle.duration}s`,
            }}
          />
        ))}

        <div className="success-icon-wrapper">
          <div className="success-circle">
            <svg className="checkmark" viewBox="0 0 52 52">
              <circle
                className="checkmark-circle"
                cx="26"
                cy="26"
                r="25"
                fill="none"
              />
              <path
                className="checkmark-check"
                fill="none"
                d="M14.1 27.2l7.1 7.2 16.7-16.8"
              />
            </svg>
          </div>
        </div>

        <h1 className="success-title">You're on the List! 🎉</h1>

        <p className="success-message">
          Welcome to the CodeFox family! You'll receive exclusive updates and
          early access notifications at:
        </p>

        <div className="email-badge">{email}</div>

        <p className="success-footer-text">
          Get ready to level up your DSA skills
        </p>
      </div>
    </div>
  );
}

export default SuccessPage;
